import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, inject, Input, Output } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { BadgeComponent } from '@sb/ui/badge';
import { ButtonComponent, ButtonThemePalette } from '@sb/ui/button';
import { IconComponent, type Icon } from '@sb/ui/icon';
import { LaddaDirective } from '@sb/ui/ladda';
import { clsx } from 'clsx';

import { ChapterSubtitleDirective } from '../chapter-subtitle.directive';
import { ChapterTitleDirective } from '../chapter-title.directive';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'chapter-step',
  imports: [
    ChapterSubtitleDirective,
    ChapterTitleDirective,
    ButtonComponent,
    LaddaDirective,
    BadgeComponent,
    IconComponent,
  ],
  templateUrl: './chapter-step.component.html',
})
export class ChapterStepComponent {
  private translate = inject(TranslateService);

  @HostBinding('class')
  hostClasses = clsx('flex flex-col gap-6 text-sm font-semibold text-default');

  @Input()
  title: string | SafeHtml;

  @Input()
  subtitle?: string | SafeHtml;

  @Input()
  nextButtonLabel: string | SafeHtml = this.translate.instant('Next');

  @Input()
  showSkipButton = false;

  @Input()
  skipButtonLabel: string | SafeHtml = this.translate.instant('Skip');

  @Input()
  nextButtonLoading = false;

  @Input()
  nextButtonDisabled = false;

  @Input()
  skipButtonDisabled = false;

  @Input()
  skipButtonLoading = false;

  @Input()
  skipButtonTheme = ButtonThemePalette.transparent;

  @Input()
  skipButtonIcon: Icon;

  @Input()
  badge: string;

  @Output()
  next = new EventEmitter<void>();

  @Output()
  skip = new EventEmitter<void>();
}
